import { render, staticRenderFns } from "./marketingList.vue?vue&type=template&id=bd6f1aae&scoped=true&"
import script from "./marketingList.vue?vue&type=script&lang=ts&"
export * from "./marketingList.vue?vue&type=script&lang=ts&"
import style0 from "./marketingList.vue?vue&type=style&index=0&id=bd6f1aae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6f1aae",
  null
  
)

export default component.exports